import type { FooterLayout } from "./types";
import type { AlertSeverity, HeadingLevel } from "..";

export const DEFAULT_SEVERITY = "info" satisfies AlertSeverity;

export const DEFAULT_HEADING_LEVEL = 2 as const satisfies HeadingLevel;

export const FOOTER_LAYOUTS = ["inline", "stacked"] as const;
export const DEFAULT_FOOTER_LAYOUT = "inline" satisfies FooterLayout;
